import { memo } from "react";
import { Body, Alert } from "@rikstv/shared-components";
import config from "~/config";
import { hasLoggedOnRecently } from "../../utils/cookie-service";

const MinSideBanner = () => {
  if (!hasLoggedOnRecently()) {
    return null;
  }

  return (
    <Alert
      intent="info"
      variant="translucent"
      heading="Allerede kunde?"
      style={{ marginBottom: "24px" }}
    >
      <Body style={{ marginBottom: "12px" }}>
        Da må du logge inn på Min side for å bestille eller endre abonnement.
      </Body>
      <a
        className="link-style"
        href={config.myPageLink}
        aria-label="Gå til Min side"
        rel="noopener"
      >
        Gå til Min side
      </a>
    </Alert>
  );
};

export default memo(MinSideBanner);
